import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'

import { useNavigation, useRoute } from '@react-navigation/native'
import { B1, H5, SH3, Stack, colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ArrowRight from '@zet/design-system/svg/ArrowRight'
import Close from '@zet/design-system/svg/Close'
import useDsaStore from '@zet/feature-user/api/freshchat/store/dsa'
import storageUtil from '@zet/utils/storage'

import { useGetDsaList, useSubmitSelectedDsa } from '../../../api/login/hooks'
import { bridgeApi } from '../../../api/network'
import { i18n } from '../../../localization'
import useStore from '../../../store'
import useAuthStore from '../../../store/authStore'

const MultipleAccount = () => {
  const navigation = useNavigation()
  const { params } = useRoute()
  const { setSelectedDsaId } = useStore((state) => state)
  const { setSelectedDsaId: setSelectedDsa } = useDsaStore((state) => state)
  const { setIsAuthenticated } = useAuthStore()
  const { mutate, isLoading } = useSubmitSelectedDsa()
  const [isDsaSelected, setIsDsaSelected] = useState(false)

  const { refetch, data: dsaList } = useGetDsaList()

  useEffect(() => {
    refetch()
  }, [refetch])

  useEffect(() => {
    if (isDsaSelected) navigation.replace('HomeView')
  }, [isDsaSelected, navigation])

  async function storeToken(token) {
    storageUtil.saveObject('token', token)
  }

  const handleSelectedDsa = (id: number) => {
    mutate(id, {
      onSuccess: (selectedDsaData) => {
        if (selectedDsaData && selectedDsaData?.jwtToken) {
          bridgeApi.defaults.headers.common = {
            ...bridgeApi.defaults.headers.common,
            Authorization: `Bearer ${selectedDsaData?.jwtToken}`,
            Accept: 'application/json',
            locale: i18n.locale,
          }
          if (selectedDsaData?.action === 'SHOW_BRIDGE_ONBOARDING_SCREEN') {
            const updatedDsaList = params?.data?.filter((i) => i.dsaId === id)
            navigation.navigate('UserDetails', {
              selectedDsaData: selectedDsaData?.actionData,
              dsaList: updatedDsaList,
              token: selectedDsaData?.jwtToken,
              dsaId: id,
            })
          } else if (selectedDsaData?.action === 'SHOW_BRIDGE_HOME_SCREEN') {
            setSelectedDsaId(id)
            setSelectedDsa(id)
            storeToken(selectedDsaData?.jwtToken)
            setIsAuthenticated(true)
            setIsDsaSelected(true)
          }
        }
      },
    })
  }

  return (
    <Stack className="bg-neutral-white100 flex-1 px-3 pt-3">
      {params?.handleBack && (
        <Pressable
          className="bg-grays-20 mb-3 mr-3 h-5 w-5 items-center justify-center rounded"
          onPress={() => navigation.replace('HomeView')}
        >
          <Close color={zetColors.grays[50]} />
        </Pressable>
      )}
      <B1 className="text-grays-60 mb-3">
        {i18n.t('multipleAccounts.yourProfile')}
      </B1>
      <ScrollView>
        {dsaList?.map((d) => (
          <Pressable
            className="bg-primary-10 border-primary-20 mb-2 flex-row items-center justify-between rounded px-3 py-3"
            key={d?.dsaId}
            disabled={isLoading}
            onPress={() => handleSelectedDsa(d?.dsaId)}
          >
            <Stack>
              <H5 className="text-primary-200">{d.organisationName}</H5>
              <SH3 className="text-grays-60">{d.dsaName}</SH3>
            </Stack>
            <Stack>
              <ArrowRight />
            </Stack>
          </Pressable>
        ))}
      </ScrollView>
    </Stack>
  )
}

export default MultipleAccount
